import * as React from 'react';
import ReactDOM from 'react-dom';

import { Home } from './Home.js';
import { Fatture } from './Fatture.js';
import { StatoRichieste } from './StatoRichieste.js';
import { Contratti } from './Contratti.js';
import { Moduli } from './Moduli.js';
import { Registri } from './Registri.js';
import { Curve } from './Curve.js';
import { DatiCatastali } from './DatiCatastali.js';
import { Documenti } from './Documenti.js';

// import { Loading } from './Loading.js';
import { ElencoUtenti } from './ElencoUtenti.js';

import { Nav } from 'office-ui-fabric-react/lib/Nav';
import { Panel, PanelType } from 'office-ui-fabric-react/lib/Panel';
import { DefaultButton } from 'office-ui-fabric-react/lib/Button';

import { Screen } from './classi/Screen.js';
import { Session } from './classi/Session.js';
import { Utils } from './classi/Utils.js';
import { Config } from './Config.js';

const sessione = new Session();
const screen = new Screen();
const utils = new Utils();
const config = new Config();

var _listmenu = [ 'homemenubtn','richiestemenubtn','fatturemenubtn','curvemenubtn','registrimenubtn','documentimenubtn','daticatastalimenubtn','contrattimenubtn','modulimenubtn','sceglimenubtn' ];
var _menulinks = [];

export class AreaClientePanel extends React.Component {
    constructor() {
        super();
        
        this.state = {
            menuOpen: false,
            info : {},
            defaultinfo : {
                footercolor : '#EEE'
            },
            id_cliente: false,
            menuselezionato: 'homemenubtn',
            vedilogo : '',
            version : config.getVersion(),
            classeHeader:'loggato',
            
            vediImage1 : 'nascosto',
            vediImage2 : 'nascosto',
            
            linkImage1 : '',
            linkImage2 : '',
            linkLogo : ''
        };  
        
        this.home = this.home.bind(this);
        this.fatture = this.fatture.bind(this);
        this.statoRichieste = this.statoRichieste.bind(this);
        this.curve = this.curve.bind(this);
        this.registri = this.registri.bind(this);
        this.toggleMenu = this.toggleMenu.bind(this);
        this.logout = this.logout.bind(this);
        this.coloraMenu = this.coloraMenu.bind(this);
        this._hideMenu = this._hideMenu.bind(this);
        this.daticatastali = this.daticatastali.bind(this);
        this.documenti = this.documenti.bind(this);
        this.contratti = this.contratti.bind(this);
        this.moduli = this.moduli.bind(this);
        this.scegliutente = this.scegliutente.bind(this);
        
        this.centralogo = this.centralogo.bind(this);
        
        screen.resize();
    }

    centralogo(conta){
        let posLogo = utils.getObjInfoSocieta( 'POSIZIONELOGOAC2' , false );
        if( posLogo !== false && conta < 50 ) {  if(posLogo === 'centro'){ this.setState({classeHeader: 'pagecentrato loggato'}); } }
        else { setTimeout( function(){  this.centralogo( conta+1 );  }.bind(this) , 25 ); }
    }
    
    mostraImage(conta){
        let colori = utils.getObjInfoSocieta( 'colori' , false );
        
        if(colori !== false && conta < 50)
        {
            if('--addImage1' in colori){
                if( colori['--addImage1'] !== "url('')") { this.setState({ vediImage1 : 'image1' }); }
            }
            if('--addImage2' in colori){
                if( colori['--addImage2'] !== "url('')") { this.setState({ vediImage2 : 'image2' });}
            }
        }
        else {
            setTimeout( function(){  this.mostraImage(conta+1);  }.bind(this) , 25 );
        }
    }
    
    controllaLink(conta){
        let link1 = utils.getObjInfoSocieta( 'ADDIMAGE1LINK' , false );
        let link2 = utils.getObjInfoSocieta( 'ADDIMAGE2LINK' , false );
        let linkLogo = utils.getObjInfoSocieta( 'LOGOLINK' , false );
        
        if( (link1 !== false || link2 !== false || linkLogo !== false) && conta < 50){
            this.setState({ linkImage1 : link1, linkImage2 : link2 , linkLogo:linkLogo });
        } else {
            setTimeout( function(){  this.controllaLink(conta+1);  }.bind(this) , 25 );
        }
    }

    coloraMenu() {
        setTimeout( function test(){

            for (let i = 0; i < _listmenu.length; i++) {
                const ele = document.getElementById( _listmenu[i] );
                if (null != ele){ ele.classList.remove("ActiveLeftMenu"); }
            }

            const ele2 = document.getElementById( this.state.menuselezionato );
            if (null != ele2){ ele2.classList.add("ActiveLeftMenu"); }
        }.bind(this) ,50);
    }

    toggleMenu() {
       if( this.state.menuOpen){ this.coloraMenu(); }
       this.setState({menuOpen: !this.state.menuOpen});
       if( this.state.menuOpen){ this.coloraMenu(); }
    }
    
    _hideMenu(){
        this.setState({menuOpen: false});
    }
    
    home() {
        sessione.set('maschera' , 'home');
        ReactDOM.render(<Home />, document.getElementById('ac-container'));
        this.setState({menuselezionato:'homemenubtn'});
        this.coloraMenu();
        
        // se mobile chiudi il Menu
        if( screen.isMobile() === true ) { this.toggleMenu(); this.setState({ menuOpen: false }) }
    }
    fatture(){
        sessione.set('maschera' , 'fatture');
        ReactDOM.render(<Fatture />, document.getElementById('ac-container'));
        this.setState({menuselezionato:'fatturemenubtn'});
        this.coloraMenu();
        
        // se mobile chiudi il Menu
        if( screen.isMobile() === true ) { this.toggleMenu(); this.setState({ menuOpen: false }) }
    }
    statoRichieste(){
        sessione.set('maschera' , 'statoRichieste');
        ReactDOM.render(<StatoRichieste />, document.getElementById('ac-container'));
        this.setState({menuselezionato:'richiestemenubtn'});
        this.coloraMenu();
        
        // se mobile chiudi il Menu
        if( screen.isMobile() === true ) { this.toggleMenu(); this.setState({ menuOpen: false }) }
    }
    curve(){
        sessione.set('maschera' , 'curve');
        ReactDOM.render(<Curve />, document.getElementById('ac-container'));
        this.setState({menuselezionato:'curvemenubtn'});
        this.coloraMenu();
        
        // se mobile chiudi il Menu
        if( screen.isMobile() === true ) { this.toggleMenu(); this.setState({ menuOpen: false }) }
    }
    registri(){
        sessione.set('maschera' , 'registri');
        ReactDOM.render(<Registri />, document.getElementById('ac-container'));
        this.setState({menuselezionato:'registrimenubtn'});
        this.coloraMenu();
        
        // se mobile chiudi il Menu
        if( screen.isMobile() === true ) { this.toggleMenu(); this.setState({ menuOpen: false }) }
    }
    daticatastali(){
        sessione.set('maschera' , 'daticatastali');
        ReactDOM.render(<DatiCatastali />, document.getElementById('ac-container'));
        this.setState({menuselezionato:'daticatastalimenubtn'});
        this.coloraMenu();
        
        // se mobile chiudi il Menu
        if( screen.isMobile() === true ) { this.toggleMenu(); this.setState({ menuOpen: false }) }
    }
    documenti(){
        sessione.set('maschera' , 'documenti');
        ReactDOM.render(<Documenti />, document.getElementById('ac-container'));
        this.setState({menuselezionato:'documentimenubtn'});
        this.coloraMenu();
        
        // se mobile chiudi il Menu
        if( screen.isMobile() === true ) { this.toggleMenu(); this.setState({ menuOpen: false }) }
    }
    contratti(){
        sessione.set('maschera' , 'contratti');
        ReactDOM.render(<Contratti />, document.getElementById('ac-container'));
        this.setState({menuselezionato:'contrattimenubtn'});
        this.coloraMenu();
        
        // se mobile chiudi il Menu
        if( screen.isMobile() === true ) { this.toggleMenu(); this.setState({ menuOpen: false }) }
    }
    moduli(){
        sessione.set('maschera' , 'moduli');
        ReactDOM.render(<Moduli />, document.getElementById('ac-container'));
        this.setState({menuselezionato:'modulimenubtn'});
        this.coloraMenu();
        
        // se mobile chiudi il Menu
        if( screen.isMobile() === true ) { this.toggleMenu(); this.setState({ menuOpen: false }) }
    }
    scegliutente(){
        sessione.set('maschera' , 'scegliutente');
        ReactDOM.render(<ElencoUtenti />, document.getElementById('ac-container'));
        this.setState({menuselezionato:'sceglimenubtn'});
        this.coloraMenu();
        
        // se mobile chiudi il Menu
        if( screen.isMobile() === true ) { this.toggleMenu(); this.setState({ menuOpen: false }) }
    }
    logout() {
        // se mobile chiudi il Menu
        if( screen.isMobile() === true ) { this.toggleMenu(); this.setState({ menuOpen: false }) }
        utils.dialogLogout();
    }
    
    componentDidMount() {
        this.centralogo(0);

        this.mostraImage(0);
        this.controllaLink(0);

        this.setState({id_cliente: sessione.get('id_cliente') , info: sessione.get('datainfo') });

        
        // settaggio temporaneo da riassegnare se ho i default
        var _info =  this.state.info;
        
        // prendi eventuali default se mancanti
        if( !( 'logo' in this.state.info) ) {  
            _info.logo = sessione.get('imglogosocieta') ;
            if( _info.logo === '' ){ this.setState({vedilogo:'nascosto'});}
        }
        if( !( 'footercolor' in this.state.info) ) { _info.footercolor = this.state.defaultinfo.footercolor ; }
        
        // ora aggiorna INFO
        this.setState({ info : _info });
        
        window.addEventListener("resize", this.resize.bind(this) );
        this.resize();

        // Selezione Utenti per Aggregati e Amministratori       
        // console.log( 'id_amministratore' , sessione.get('id_amministratore') );
        // console.log( 'id_aggregato' , sessione.get('id_aggregato') );
        
        let ID_CLIENTE = sessione.get('id_cliente');
        let ID_AGGREGATO = sessione.get('id_aggregato');
        let ID_AMMINISTRATORE = sessione.get('id_amministratore');

        
        if( ( ID_AMMINISTRATORE !== '' && ID_AMMINISTRATORE !== 0 && ID_AMMINISTRATORE !== null ) || ( ID_AGGREGATO !== '' && ID_AGGREGATO !== 0 && ID_AGGREGATO !== null ) ){
            let nomeTabU = 'Utenti';
            let alternativa = utils.getObjUser('MENU_ALT_UTENTI' , 'menu' , '');
            if( alternativa !== null && alternativa.trim() !=='' ){ nomeTabU = alternativa; }
            _menulinks.push({name: nomeTabU, icon: "People", onClick: this.scegliutente, rel:'Utenti', id:'sceglimenubtn' });
        }

        if(  ID_CLIENTE!==-9999 ){
            _menulinks.push({name: "Home", icon: "Home", onClick: this.home, rel: 'Home', id : 'homemenubtn' } );
        }
        
        // Menu Richieste
        if( utils.getMenuUser( 'richieste', true ) !== false && ID_CLIENTE!==-9999 ){
            _menulinks.push({name: "Stato Richieste", icon: "TaskLogo", onClick: this.statoRichieste, rel: 'Richieste', id:'richiestemenubtn'});
        }

        // Menu Fatture
        if( utils.getMenuUser( 'fatture', true ) !== false && ID_CLIENTE!==-9999 ){
            _menulinks.push({name: "Fatture", icon: "Money", onClick: this.fatture, rel:'Fatture', id:'fatturemenubtn' });
        }
        
        // Menu Curve
        if( utils.getMenuUser( 'curve', true ) !== false && ID_CLIENTE!==-9999 ){
            _menulinks.push({name: "Curve", icon: "LineChart",onClick: this.curve, rel:'Curve', id:'curvemenubtn'});
        }
        
        // Menu Registri
        if( utils.getMenuUser( 'registri', true ) !== false && ID_CLIENTE!==-9999 ){
            
            let nomeTab = 'Registri';
            let alternativa = utils.getObjUser('MENU_ALT_REGISTRI' , 'menu' , '');
            if( alternativa !== null && alternativa.trim() !=='' ){ nomeTab = alternativa; }
            _menulinks.push({name: nomeTab, icon: "IssueTracking", onClick: this.registri, rel:'Registri', id:'registrimenubtn' });
        }

        // Menu Documenti
        if( utils.getMenuUser( 'documenti', true ) !== false && ID_CLIENTE!==-9999 ){
            _menulinks.push({name: "Documenti", icon: "Documentation", onClick: this.documenti, rel:'Documenti', id:'documentimenubtn' });
        }

        // Dati Catastali
        if( utils.getMenuUser( 'dati_catastali', true ) !== false && ID_CLIENTE!==-9999 ){
            _menulinks.push({name: "Dati Catastali", icon: "ContactCardSettings", onClick: this.daticatastali, rel:'Dati Catastali', id:'daticatastalimenubtn' });
        }

        // Contratti
        if( utils.getMenuUser( 'contratti', true ) !== false && ID_CLIENTE!==-9999 ){
            _menulinks.push({name: "Contratti", icon: "ContactInfo", onClick: this.contratti, rel:'Contratti', id:'contrattimenubtn' });
        }
        
        // Moduli
        if( utils.getMenuUser( 'moduli', true ) !== false && ID_CLIENTE!==-9999 ){
            _menulinks.push({name: "Moduli", icon: "FabricFolderSearch", onClick: this.moduli, rel:'Moduli', id:'modulimenubtn' });
        }
        
        // Logout
        _menulinks.push({name: "ESCI", icon: "SignOut",onClick: this.logout});
        
        
        screen.resize();
        if( screen.isMobile() ){ this.setState({menuOpen: false}); }
        
        if( sessione.get('maschera')===null){ 
            if( ID_CLIENTE === -9999 ){
                this.scegliutente();
            } else {
                this.home();
            }
        }
        else {
            switch( sessione.get('maschera') ) {
                case 'home':
                    this.home();
                    break;
                case 'fatture':
                    this.fatture();
                    break;
                case 'statoRichieste':
                    this.statoRichieste();
                    break;
                case 'curve':
                    this.curve();
                    break;
                case 'registri':
                    this.registri();
                    break;
                case 'documenti':
                    this.documenti();
                    break;
                case 'daticatastali':
                    this.daticatastali();
                    break;
                case 'contratti':
                    this.contratti();
                    break;
                case 'moduli':
                    this.moduli();
                    break;
                case 'scegliutente':
                    if( ID_CLIENTE === -9999 ){
                        this.scegliutente();
                    } else {
                        this.home();
                    }
                    break;
                default:
                    this.home();
                    break;
            }
        }
    }
    
    resize() {
        screen.resize();
        
        var neww = screen.getWidth() -6;

        document.getElementById('root').setAttribute("style","width:"+neww+"px");
        document.getElementById('main-container').setAttribute("style","width:"+neww+"px");
        document.getElementById('ac-container').setAttribute("style","width:"+neww+"px");

        if( !screen.isMobile() ) { this.setState({menuOpen: true}); }
        else { this.setState({menuOpen: false}); }
    }
    
    render() {
        var footerstyle = {};
        var bgcolor = '#CCC';
        var bgimg = 'transparent';
        
        if('footercolor' in this.state.info && this.state.info.footercolor != null) bgcolor = this.state.info.footercolor;
        if('footerimg' in this.state.info && this.state.info.footerimg != null) bgimg = 'url('+this.state.info.footerimg+')';
        
        footerstyle = {'backgroundColor':bgcolor, 'backgroundImage':bgimg , 'backgroundPositionX':'center' , 'backgroundRepeatX':'no-repeat'};

        return (
            <div id="main-container">
    
                <header className={this.state.classeHeader}><div id="ac-navigator">

                    <DefaultButton id='bottoneaprimenu' iconProps={{iconName: "WaffleOffice365"}} onClick={this.toggleMenu} onDismiss={() => this.setState({ menuOpen: false })} className='ms-bgColor-themePrimary' title="Menu" ariaLabel="Menu"/>
                        <a href={this.state.linkLogo} target="_blank" className="logoclick"><span>&nbsp;</span></a>
                        <a href={this.state.linkImage1} target="_blank" className="linkimage"><span className={this.state.vediImage1}>&nbsp;</span></a>
                        <a href={this.state.linkImage2} target="_blank" className="linkimage"><span className={this.state.vediImage2}>&nbsp;</span></a>
                    <DefaultButton id='bottonelogout' iconProps={{iconName: "SignOut"}} onClick={this.logout} className='ms-bgColor-themePrimary'  title="Esci" ariaLabel="Esci"/>
                </div></header>

                <Panel isOpen={this.state.menuOpen} isBlocking={true} type={PanelType.smallFixedNear} id="mainMenu" isHiddenOnDismiss='false' onDismiss={this._hideMenu} isLightDismiss={true}>
                    <div id='logo' className={this.state.vedilogo} >
                        <a href={this.state.linkLogo} target="_blank" className="linkimage">
                        <img src={this.state.info.logo} className={'imglogo '+this.state.vedilogo} alt='Logo'/></a>
                    </div>
                    <Nav id='navmenu' groups={[{ links: _menulinks }]} />
                    <div id='versionnumber'><i className="ms-Icon ms-Icon--Info" aria-hidden="true"></i> Versione {this.state.version}</div>   
                    
                    <div className='immagini'>
                        <a href={this.state.linkImage1} target="_blank" className="linkimage"><span className={this.state.vediImage1}>&nbsp;</span></a>
                        <a href={this.state.linkImage2} target="_blank" className="linkimage"><span className={this.state.vediImage2}>&nbsp;</span></a>
                    </div>
                </Panel>
                
                <div id="ac-container"></div>
                
                <footer style={footerstyle}><div id='versionfooter'><i className="ms-Icon ms-Icon--Info" aria-hidden="true"></i> Versione {this.state.version}</div></footer>
                <div id="dialogcontainer"></div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/AcComponents/AreaClientePanel.js